import { useCallback } from 'react';

import { useCoreDispatch } from '../CoreStore';
import {
  fetchOlderHistoryAction,
  fetchSingleHistoryAction,
  fetchTodayHistoryAction,
} from '../apiActions/fetchHistoryAction';
import { useConfigSlice } from '../slices/config/selectors';

export const useTodayHistoryFetcher = () => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const userId = useConfigSlice.userId();
  const env = useConfigSlice.env();

  return useCallback(() => {
    if (JSESSIONID && userId && env) {
      return dispatch(
        fetchTodayHistoryAction({
          env: env.report,
          JSESSIONID,
          userId,
        })
      );
    }
  }, [JSESSIONID, userId, env, dispatch]);
};

export const useOlderHistoryFetcher = () => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const env = useConfigSlice.env();
  const countPerPage: number = 20;

  return useCallback(
    (page: number = 0) => {
      if (JSESSIONID && env) {
        return dispatch(
          fetchOlderHistoryAction({
            env: env.report,
            JSESSIONID,
            rowStart: (page - 1) * countPerPage,
            rowEnd: page * countPerPage,
          })
        );
      }
    },
    [JSESSIONID, env, dispatch]
  );
};

export const useSingleHistoryFetcher = () => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const userId = useConfigSlice.userId();
  const env = useConfigSlice.env();

  return useCallback(
    (gameId: number) => {
      if (JSESSIONID && userId && env) {
        return dispatch(
          fetchSingleHistoryAction({
            env: env.report,
            JSESSIONID,
            userId,
            gameId,
          })
        );
      }
    },
    [JSESSIONID, userId, env, dispatch]
  );
};
